export default "__VITE_ASSET__MUSFiNAP__"